import { Component, inject} from '@angular/core';
import { RouterLink } from '@angular/router';
import { UserContextSelectors } from '@app/shared/state/user-context/user-context.selectors';
import { Store } from '@ngxs/store';

@Component({
  selector: 'kp-logo',
  imports: [RouterLink],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss'
})
export class LogoComponent {

  #store = inject(Store)
  isMf = this.#store.selectSignal(UserContextSelectors.isMf)
}
